import React from 'react';
import TouchableText from './TouchableText';
import {THEME_COLORS} from '../themes';

interface IHyperlinkTextProps{
    onPress:(obj?:any)=>void;
    fontSize?:string;
    disabled?:boolean;
    text:string;
}

export const HyperlinkText=(props:IHyperlinkTextProps)=>{

    const font_size = props.fontSize ?? "small";

    return (
        <TouchableText 
            disabled={!!props.disabled}
            onPress={props.onPress} 
            text={props.text ?? ""} 
            textStyles={{color:THEME_COLORS.hyperlink,textDecorationLine: 'underline'}}
            typeOfSix={'one_six'}
            fontSize={font_size}
        />
    )
}